import { SelectedProduct, V3Product } from '../../../../utils/state/types';

export type ProductAddonLine = {
  key: string;
  name: string;
  quantity: number;
  unitPrice: number;
};

export function getProductAddonsTotal(lines: ProductAddonLine[]): number {
  return lines.reduce(
    (sum, { unitPrice, quantity }) => sum + unitPrice * quantity,
    0,
  );
}

export function getProductAddonLines(
  selectedProductAddons: SelectedProduct[],
  relatedProducts: V3Product[],
  bookingCurrency?: string,
): ProductAddonLine[] {
  return selectedProductAddons.flatMap(({ productId, variantId, quantity }) => {
    const product = relatedProducts.find((p) => p._id === productId);
    if (!product) {
      return [];
    }
    // Product and booking catalogs convert prices independently. Do not add
    // mismatched currencies here; eCom calculates the authoritative total.
    if (
      product.currency &&
      bookingCurrency &&
      product.currency !== bookingCurrency
    ) {
      return [];
    }
    const variant = product.variantsInfo?.variants?.find(
      (v) => v._id === variantId,
    );
    const unitPrice = parseFloat(
      variant?.price?.actualPrice?.amount ??
        product.actualPriceRange?.minValue?.amount ??
        '0',
    );
    return [
      {
        key: `${productId}-${variantId}`,
        name: product.name ?? '',
        quantity,
        unitPrice,
      },
    ];
  });
}
